import { createIcon } from '@chakra-ui/icons'

const WOFFIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <>
      <path
        d="M68.5 83.5h-59C7 83.5 5 81.5 5 79V8c0-2.5 2-4.5 4.5-4.5h44.4L73 20.7V79c0 2.4-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M68.5 83c2.2 0 4-1.8 4-4V21L53.6 4H9.5c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5V8c0-2.8 2.2-5 5-5H54l19.4 17.6V79c.1 2.7-2.2 5-4.9 5z"
        fill="#E1E4EA"
      />
      <path
        d="M73.5 33h-69V8c0-2.8 2.2-5 5-5H55l18.4 17.5V33z"
        fill="#277FAF"
      />
      <path
        d="M55.2 3v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0L55.2 3z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(11.467 21.968)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        WOFF
      </text>
      <path
        d="M27.3 47.9v-2.7h10.5v26.5h-2.3c-.6 0-1.2.5-1.2 1.2 0 .6.5 1.2 1.2 1.2h7c.6 0 1.2-.5 1.2-1.2 0-.6-.5-1.2-1.2-1.2h-2.3V45.2h10.5v2.7c0 .6.5 1.2 1.2 1.2.6 0 1.2-.5 1.2-1.2V44c0-.6-.5-1.2-1.2-1.2H26.1c-.6 0-1.2.5-1.2 1.2v3.9c0 .6.5 1.2 1.2 1.2s1.2-.6 1.2-1.2z"
        fill="#E1E4EB"
      />
    </>
  ),
})

export default WOFFIcon
